var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g4, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRentalsStep2 = function SvgCarRentalsStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 185,
    viewBox: "0 0 207 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.598 163.411C173.757 163.411 180.423 145.379 180.423 81.7053C180.423 18.0315 173.757 0 104.598 0C35.4393 0 28.7734 18.0315 28.7734 81.7053C28.7734 145.379 35.4393 163.411 104.598 163.411Z",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8168_48903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.3288 132.509H37.3807C36.2122 132.509 35.2773 131.566 35.2773 130.388V55.4167C35.2773 54.238 36.2122 53.2949 37.3807 53.2949H88.3288C89.4974 53.2949 90.4322 54.238 90.4322 55.4167V130.388C90.4322 131.566 89.4974 132.509 88.3288 132.509Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.079 65.4353H41.2363C40.8857 65.4353 40.5352 65.0817 40.5352 64.728V64.0208C40.5352 63.6671 40.8857 63.3135 41.2363 63.3135H47.079C47.4295 63.3135 47.7801 63.6671 47.7801 64.0208V64.728C47.7801 65.0817 47.4295 65.4353 47.079 65.4353Z",
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2764 65.4353H52.8046C52.4541 65.4353 52.1035 65.0817 52.1035 64.728V64.0208C52.1035 63.6671 52.4541 63.3135 52.8046 63.3135H87.2764C87.627 63.3135 87.9775 63.6671 87.9775 64.0208V64.728C87.9775 65.0817 87.627 65.4353 87.2764 65.4353Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.079 72.3913H41.2363C40.8857 72.3913 40.5352 72.0377 40.5352 71.6841V70.9768C40.5352 70.6232 40.8857 70.2695 41.2363 70.2695H47.079C47.4295 70.2695 47.7801 70.6232 47.7801 70.9768V71.6841C47.7801 72.0377 47.4295 72.3913 47.079 72.3913Z",
    fill: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2764 72.3913H52.8046C52.4541 72.3913 52.1035 72.0377 52.1035 71.6841V70.9768C52.1035 70.6232 52.4541 70.2695 52.8046 70.2695H87.2764C87.627 70.2695 87.9775 70.6232 87.9775 70.9768V71.6841C87.9775 72.0377 87.627 72.3913 87.2764 72.3913Z",
    fill: "#F4F4F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1566 115.182H49.1836V125.673H53.1566V115.182Z",
    fill: "url(#paint0_linear_8168_48903)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4008 113.296H56.4277V125.791H60.4008V113.296Z",
    fill: "url(#paint1_linear_8168_48903)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7621 116.831H63.7891V125.79H67.7621V116.831Z",
    fill: "url(#paint2_linear_8168_48903)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0082 119.778H71.0352V125.79H75.0082V119.778Z",
    fill: "url(#paint3_linear_8168_48903)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8168_48903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8844 85.3422C76.3617 84.9741 75.7195 84.7388 75.0206 84.5879V84.5819C74.9609 84.5698 74.8952 84.5577 74.8295 84.5487C74.5547 84.4974 74.2709 84.4581 73.9812 84.425C71.7112 84.1564 67.2429 83.8486 65.1789 83.8486C62.7447 83.8486 60.9824 88.0337 60.9824 88.0337L78.7363 89.1381V89.1532C78.8229 89.1532 78.8856 89.1502 78.9244 89.1502C79.6353 89.1502 80.3103 88.6945 80.3103 88.6945L80.3432 88.7157C80.0893 88.2872 79.1813 86.9686 76.8814 85.3422H76.8844Z",
    fill: "url(#paint4_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8844 85.3422C76.3617 84.9741 75.7195 84.7388 75.0206 84.5879V84.5819C74.9609 84.5698 74.8952 84.5577 74.8295 84.5487C74.5547 84.4974 74.2709 84.4581 73.9812 84.425C71.7112 84.1564 67.2429 83.8486 65.1789 83.8486C62.7447 83.8486 60.9824 88.0337 60.9824 88.0337H61.5678C61.5678 88.0337 63.0284 84.6663 64.9908 84.4008C66.4961 84.1986 70.7494 84.434 73.2434 84.7418C73.9991 84.8353 74.6562 84.9138 75.1132 85.0073C75.8629 85.1612 76.4424 85.5142 77.0278 85.9276C77.4579 86.2324 77.8402 86.5431 78.1777 86.8479L78.7422 89.1562C78.8259 89.1562 78.8886 89.1532 78.9274 89.1532C79.6383 89.1532 80.3133 88.6976 80.3133 88.6976L80.4119 88.8484C80.158 88.42 79.1843 86.9716 76.8874 85.3452L76.8844 85.3422Z",
    fill: "url(#paint5_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6854 89.0764L62.1018 88.0264L48.2876 88.316C48.2876 88.316 46.5104 92.7486 50.0528 93.4637C53.5952 94.1788 78.7953 94.7249 79.6854 92.4951C80.5754 90.2653 79.6854 89.0764 79.6854 89.0764Z",
    fill: "url(#paint6_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4787 87.0668C66.4698 87.0456 66.4638 87.0306 66.4548 87.0125C66.428 86.9461 66.422 86.94 66.4011 86.9038C66.2458 86.6172 66.0277 86.3999 65.6036 86.2279C65.5618 86.2189 65.4244 86.1374 64.9525 86.1133C64.824 86.1133 64.7075 86.1133 64.5821 86.1314C62.9184 86.3124 61.649 87.9026 61.8611 89.025C62.0433 90.0389 63.25 90.7148 64.9106 89.882C65.3975 89.6376 65.8545 89.2483 66.1651 88.7867C66.3593 88.5 66.5056 88.1681 66.5564 87.8241V87.8332C66.6251 87.3504 66.4489 86.9762 66.4787 87.0668ZM62.9692 87.3082C63.0917 87.2026 63.0917 87.2026 63.1036 87.1905C63.6681 86.7288 64.2655 86.578 64.2715 86.5749C65.8336 86.1465 66.416 87.0396 66.1323 88.0082L62.6466 87.6612C62.7273 87.5586 62.8139 87.459 62.9095 87.3625C62.9304 87.3414 62.9513 87.3232 62.9692 87.3051V87.3082ZM63.2081 89.8639C63.2081 89.8639 63.2141 89.8639 63.2171 89.8639H63.2081ZM63.928 89.8337C63.6382 89.888 63.3366 89.9061 63.0528 89.8337L63.0827 89.8428C63.0678 89.8397 63.0379 89.8307 63.0528 89.8337C62.9304 89.8005 62.9065 89.7884 62.8766 89.7734C62.2792 89.4897 62.109 89.013 62.2225 88.5061L65.5707 88.9526C65.1884 89.3539 64.6388 89.6859 63.928 89.8307V89.8337Z",
    fill: "url(#paint7_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8192 100.278L71.2039 99.756C71.2039 99.756 73.8203 93.1148 71.0127 92.0919C68.2051 91.069 65.9948 95.1757 66.8192 100.278Z",
    fill: "url(#paint8_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7171 96.7378L83.7601 96.3697C83.7601 96.3697 84.8085 90.9173 83.6735 90.4587C82.0905 89.819 81.2482 93.8261 81.7171 96.7378Z",
    fill: "url(#paint9_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4334 102.631C67.4651 102.007 67.7787 93.3621 69.8934 93.0272C70.0188 93.0061 70.5535 93.0453 67.8175 92.9216C66.8109 92.8763 66.2345 95.0971 66.0672 96.1049C65.5714 99.0951 66.1986 102.508 67.3904 102.562C70.1652 102.686 69.5827 102.68 69.4304 102.631H69.4334Z",
    fill: "url(#paint10_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7854 93.0546C70.7293 92.7408 71.5029 94.6296 71.5148 97.2729C71.5238 99.9161 70.7651 102.315 69.8213 102.626C68.8774 102.939 68.1038 101.051 68.0919 98.4074C68.0829 95.7642 68.8416 93.3654 69.7854 93.0546Z",
    fill: "url(#paint11_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1753 96.1682C52.1753 92.6167 50.1084 91.6904 49.0869 91.8684C48.9137 91.8593 48.3731 91.8382 46.9573 91.7749C45.673 91.7175 43.8779 93.3952 43.8809 96.6932C43.8809 99.1493 45.0039 101.515 46.5302 101.415C48.9376 101.524 49.3707 101.533 49.3438 101.503C51.5421 101.476 52.1724 98.6726 52.1724 96.1682H52.1753Z",
    fill: "url(#paint12_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2594 91.4487C81.2134 91.4004 81.1716 91.3039 80.8729 91.6599C79.717 93.0388 79.6453 98.4279 80.7833 99.5413C81.0073 99.7615 80.9446 99.7012 83.0503 99.7555C81.4434 99.7133 81.5748 91.4064 83.2624 91.4487H83.2594Z",
    fill: "url(#paint13_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.113 91.4722C83.8119 91.2278 84.3944 92.8783 84.4153 95.1595C84.4392 97.4406 83.8896 99.4864 83.1936 99.7308C82.4947 99.9752 81.9123 98.3247 81.8914 96.0436C81.8675 93.7624 82.4171 91.7166 83.113 91.4692V91.4722Z",
    fill: "url(#paint14_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.304 93.6269C83.9456 92.3505 83.9306 90.4979 82.6552 91.379C82.1714 91.7109 81.9175 92.6885 81.801 94.0312C81.7323 94.8248 81.7114 95.7451 81.7174 96.7378L71.2037 99.7552C71.2037 99.7552 71.5173 98.9375 71.586 97.2477C71.6218 96.3878 71.5919 95.4162 71.4277 94.4476C71.3142 93.7747 71.0513 92.61 70.0477 92.4652C68.181 92.5799 67.3865 95.0994 67.0489 97.4107C66.8906 98.506 66.8339 99.556 66.816 100.277L61.9803 100.781C58.2706 100.715 48.1511 99.4836 45.7885 99.0069C43.4259 98.5301 42.9212 96.7438 42.9212 96.7438C42.4164 94.9002 43.3393 92.3023 44.1577 90.5673C44.7192 89.3754 48.2826 88.3193 48.2826 88.3193C50.9647 89.5625 60.451 89.6953 61.6726 89.6259V89.6017C61.6726 89.6017 64.537 89.5957 64.537 89.6017C67.9958 89.5746 69.0262 89.5655 69.0262 89.5655C69.2084 89.5565 78.2437 89.1491 78.9187 89.1491C79.6296 89.1491 80.3046 88.6935 80.3046 88.6935L81.2036 89.3C83.0764 89.3935 83.8082 89.9819 83.8082 89.9819C84.8386 91.041 84.298 93.6299 84.298 93.6299L84.304 93.6269Z",
    fill: "url(#paint15_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0519 97.4112C66.8936 98.5065 66.8369 99.5565 66.8189 100.278L61.9832 100.782C58.2736 100.715 48.1541 99.4841 45.7915 99.0074C43.4289 98.5306 42.9241 96.7443 42.9241 96.7443C42.6822 95.8572 42.7748 94.8132 42.9988 93.8145C44.0143 94.086 46.0693 94.5416 49.5848 94.9339C55.0179 95.5404 63.3661 95.0486 63.3661 95.0486L63.4169 95.8059C63.1541 97.4323 63.9784 97.0189 64.9163 97.206C65.454 97.3146 66.3709 97.381 67.0519 97.4142V97.4112Z",
    fill: "url(#paint16_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9415 89.4338C71.8669 89.4459 65.9141 90.4024 64.5162 91.3981C63.1094 92.3999 63.3693 95.0431 63.3693 95.0431C63.3693 95.0431 55.024 95.5349 49.588 94.9284C46.0754 94.5362 44.0175 94.0836 43.002 93.809C43.1304 93.2417 43.3036 92.6865 43.4858 92.1887C43.6202 91.8175 43.7576 91.4736 43.8861 91.1779C43.9876 90.9425 44.0802 90.7373 44.1609 90.5653C44.7224 89.3735 48.2857 88.3174 48.2857 88.3174C48.2857 88.3174 45.0868 89.6812 44.8926 91.3951C44.6985 93.109 45.717 93.4771 45.717 93.4771C45.717 93.4771 51.4129 94.0836 54.113 94.2043C56.8132 94.325 57.4852 91.6968 58.3872 91.3921C59.2863 91.0873 64.5551 89.5967 64.5551 89.5967C64.6506 89.5967 69.0294 89.5605 69.0294 89.5605C69.0622 89.5605 70.3227 89.5002 71.9386 89.4308L71.9415 89.4338Z",
    fill: "url(#paint17_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7168 96.7372L71.2031 99.7546C71.2031 99.7546 71.5167 98.9369 71.5854 97.2472L81.7288 94.8242C81.6601 95.6178 81.7079 95.7445 81.7138 96.7372H81.7168Z",
    fill: "url(#paint18_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9788 89.0913C78.9788 89.0913 80.3379 89.1577 80.535 88.7896C80.7321 88.4214 80.8157 87.6399 80.0571 87.5554C79.2984 87.471 78.707 87.8119 78.707 87.8119L78.9788 89.0943V89.0913Z",
    fill: "url(#paint19_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1068 88.95C79.1068 88.95 80.2179 89.0044 80.3792 88.7026C80.5405 88.4009 80.6092 87.7612 79.9879 87.6918C79.3667 87.6224 78.8828 87.9 78.8828 87.9L79.1068 88.95Z",
    fill: "url(#paint20_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1776 92.9215C58.1776 92.9215 62.4607 92.9517 62.9565 92.9215C63.4523 92.8913 62.3143 94.0108 62.3143 94.0108L57.4727 93.8116L58.1776 92.9215Z",
    fill: "url(#paint21_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8294 92.4954L43.4883 92.1876C43.6227 91.8164 43.7601 91.4725 43.8885 91.1768C44.3873 91.2884 44.7248 91.3638 44.7248 91.3638L44.8294 92.4954Z",
    fill: "url(#paint22_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7928 95.7542C70.1871 95.6245 70.5097 96.412 70.5126 97.5133C70.5156 98.6147 70.202 99.6134 69.8077 99.7432C69.4135 99.8729 69.0909 99.0854 69.0879 97.9841C69.0849 96.8827 69.3985 95.884 69.7928 95.7512V95.7542Z",
    fill: "url(#paint23_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1314 93.7291C83.4331 93.6235 83.684 94.3356 83.6929 95.3193C83.7019 96.303 83.4659 97.187 83.1672 97.2926C82.8656 97.3983 82.6147 96.6862 82.6057 95.7025C82.5968 94.7188 82.8327 93.8347 83.1314 93.7291Z",
    fill: "url(#paint24_linear_8168_48903)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8168_48903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.243 107.874H119.178C118.009 107.874 117.074 106.931 117.074 105.752V30.8992C117.074 29.7204 118.009 28.7773 119.178 28.7773H170.126C171.294 28.7773 172.229 29.7204 172.229 30.8992V105.87C172.229 106.931 171.294 107.874 170.243 107.874Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168.607 69.6807H127.592V74.5137H168.607V69.6807Z",
    fill: "#F4F4F4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.429 71.3311H140.211V72.7456H151.429V71.3311Z",
    fill: "#DFDFDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.684 71.3311H161.711V72.7456H165.684V71.3311Z",
    fill: "url(#paint25_linear_8168_48903)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.607 79.9355H127.592V84.7686H168.607V79.9355Z",
    fill: "#F4F4F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.04 81.7051H140.211V83.1196H148.04V81.7051Z",
    fill: "#DFDFDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.683 81.7051H158.789V83.1196H165.683V81.7051Z",
    fill: "url(#paint26_linear_8168_48903)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.607 90.3086H127.592V95.1416H168.607V90.3086Z",
    fill: "#F4F4F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.182 91.96H140.211V93.3745H153.182V91.96Z",
    fill: "#DFDFDF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.685 91.96H163.465V93.3745H165.685V91.96Z",
    fill: "url(#paint27_linear_8168_48903)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8168_48903)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.128 45.5851C145.128 45.5851 142.824 41.6956 141.367 41.1502C141.367 41.1502 144.431 40.5509 147.196 40.4101C149.96 40.2662 153.004 40.3261 153.644 40.6648C154.285 41.0004 159.31 44.5723 159.31 44.5723C158.474 45.5881 148.786 46.7268 145.128 45.5881V45.5851Z",
    fill: "url(#paint28_linear_8168_48903)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.686 44.3108C128.686 44.3108 130.249 41.2903 132.91 40.8947C135.571 40.4992 138.436 40.631 139.946 41.1015C141.453 41.572 142.254 41.8926 143.315 43.6785C144.377 45.4645 144.692 46.2346 144.692 46.2346L128.416 45.3326L128.689 44.3108H128.686Z",
    fill: "url(#paint29_linear_8168_48903)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.191 56.1874L136.837 55.669C136.837 55.669 134.238 49.0736 137.027 48.0577C139.815 47.0419 142.01 51.1172 141.191 56.1874Z",
    fill: "url(#paint30_linear_8168_48903)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.397 52.6716L124.368 52.306C124.368 52.306 123.327 46.8912 124.454 46.4357C126.026 45.8005 126.863 49.7799 126.397 52.6716Z",
    fill: "url(#paint31_linear_8168_48903)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.601 58.5235C140.556 57.9032 140.244 49.3181 138.144 48.9854C138.02 48.9645 137.489 49.0034 140.206 48.8806C141.205 48.8356 141.778 51.0411 141.944 52.0419C142.436 55.0115 141.814 58.4006 140.63 58.4546C137.874 58.5774 138.453 58.5714 138.604 58.5235H138.601Z",
    fill: "url(#paint32_linear_8168_48903)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M138.247 49.0124C137.309 48.7007 136.541 50.5766 136.529 53.2015C136.52 55.8265 137.274 58.2058 138.211 58.5174C139.149 58.8291 139.917 56.9532 139.929 54.3282C139.938 51.7033 139.184 49.321 138.247 49.0124Z",
    fill: "url(#paint33_linear_8168_48903)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.736 52.1055C155.736 48.5786 157.789 47.6587 158.803 47.8354C158.975 47.8265 159.512 47.8055 160.918 47.7456C162.194 47.6886 163.977 49.3547 163.974 52.6299C163.974 55.0691 162.858 57.4184 161.343 57.3196C158.952 57.4274 158.522 57.4364 158.548 57.4065C156.365 57.3795 155.739 54.5957 155.739 52.1085L155.736 52.1055Z",
    fill: "url(#paint34_linear_8168_48903)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M124.87 47.4181C126.902 47.3701 126.944 47.2742 127.24 47.6278C128.388 48.9973 128.459 54.3491 127.329 55.4548C127.107 55.6736 127.169 55.6137 125.078 55.6676C126.674 55.6256 126.543 47.3761 124.867 47.4181H124.87Z",
    fill: "url(#paint35_linear_8168_48903)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M125.016 47.4428C124.322 47.2001 123.743 48.8392 123.719 51.1046C123.696 53.37 124.242 55.4016 124.933 55.6444C125.627 55.8871 126.205 54.248 126.226 51.9826C126.25 49.7172 125.704 47.6855 125.013 47.4428H125.016Z",
    fill: "url(#paint36_linear_8168_48903)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M123.828 49.5854C124.184 48.3179 124.199 46.478 125.469 47.353C125.949 47.6826 126.201 48.6535 126.317 49.9869C126.385 50.775 126.406 51.689 126.4 52.6749L136.841 55.6714C136.841 55.6714 136.53 54.8593 136.461 53.1813C136.429 52.3273 136.455 51.3624 136.619 50.4005C136.731 49.7322 136.992 48.5756 137.989 48.4317C139.843 48.5456 140.632 51.0477 140.967 53.3431C141.124 54.4308 141.181 55.4736 141.199 56.1898L146.001 56.6902C149.685 56.6243 159.735 55.4017 162.081 54.9283C164.427 54.4548 164.929 52.6808 164.929 52.6808C165.43 50.8499 164.513 48.2699 163.7 46.5469C163.143 45.3632 159.604 44.3145 159.604 44.3145C156.94 45.549 147.52 45.6809 146.306 45.612V45.588C146.306 45.588 143.462 45.582 143.462 45.588C140.027 45.561 139.004 45.552 139.004 45.552C138.823 45.543 129.85 45.1385 129.176 45.1385C128.47 45.1385 127.8 44.686 127.8 44.686L126.907 45.2883C125.047 45.3812 124.321 45.9656 124.321 45.9656C123.297 47.0173 123.834 49.5884 123.834 49.5884L123.828 49.5854Z",
    fill: "url(#paint37_linear_8168_48903)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M133.047 40.5987H138.066L141.693 41.204C141.693 41.204 150.423 40.368 153.526 40.9313C153.802 41.0302 154.045 41.1351 154.259 41.252C155.392 41.9831 158.029 43.802 158.933 44.5692L159.595 44.3115C159.595 44.3115 155.104 40.6886 153.315 40.35C152.479 40.1912 151.052 39.7956 149.483 39.6218C148.338 39.4091 136.179 39.7027 133.047 40.5987Z",
    fill: "url(#paint38_linear_8168_48903)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M143.544 45.5846L143.396 45.246C142.755 44.2182 142.046 41.9378 140.875 41.6171C140.177 41.4284 138.923 41.1257 137.49 40.9549L134.96 45.3658C134.96 45.3658 134.723 45.3568 134.604 45.3509L137.241 40.9279C135.123 40.7032 132.673 40.7871 131.053 41.9318C130.626 42.2344 130.246 42.5431 129.911 42.8457L129.351 45.1381C129.268 45.1381 129.205 45.1351 129.167 45.1351C128.461 45.1351 127.79 44.6826 127.79 44.6826L127.758 44.7036C128.01 44.2781 128.912 42.9686 131.196 41.3534C133.987 39.3787 139.908 40.865 141.693 41.2036C143.476 41.5422 146.282 45.5696 146.294 45.5846H143.544Z",
    fill: "url(#paint39_linear_8168_48903)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M140.961 53.3395C141.118 54.4272 141.175 55.47 141.192 56.1862L145.995 56.6866C149.679 56.6207 159.728 55.3981 162.075 54.9247C164.421 54.4512 164.922 52.6772 164.922 52.6772C165.163 51.7962 165.071 50.7594 164.848 49.7676C163.84 50.0373 161.799 50.4897 158.308 50.8793C152.912 51.4816 144.621 50.9932 144.621 50.9932L144.571 51.7453C144.832 53.3605 144.013 52.9469 143.082 53.1357C142.548 53.2436 141.637 53.3095 140.961 53.3425V53.3395Z",
    fill: "url(#paint40_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M136.107 45.4203C136.182 45.4322 142.093 46.3821 143.482 47.371C144.879 48.3659 144.621 50.9909 144.621 50.9909C144.621 50.9909 152.908 51.4793 158.307 50.877C161.795 50.4874 163.839 50.0379 164.847 49.7653C164.72 49.2019 164.548 48.6505 164.367 48.1561C164.233 47.7875 164.097 47.4459 163.969 47.1523C163.869 46.9185 163.777 46.7148 163.696 46.544C163.139 45.3603 159.6 44.3115 159.6 44.3115C159.6 44.3115 162.777 45.666 162.97 47.368C163.163 49.0701 162.151 49.4356 162.151 49.4356C162.151 49.4356 156.494 50.0379 153.813 50.1578C151.134 50.2777 150.464 47.6677 149.568 47.365C148.675 47.0624 143.443 45.5821 143.443 45.5821C143.348 45.5821 139 45.5461 139 45.5461C138.967 45.5461 137.715 45.4862 136.11 45.4173L136.107 45.4203Z",
    fill: "url(#paint41_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M126.397 52.6713L136.838 55.6679C136.838 55.6679 136.526 54.8558 136.458 53.1777L126.385 50.7715C126.453 51.5596 126.406 51.6854 126.4 52.6713H126.397Z",
    fill: "url(#paint42_linear_8168_48903)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.118 45.0787C129.118 45.0787 127.768 45.1446 127.572 44.779C127.376 44.4134 127.293 43.6373 128.047 43.5534C128.8 43.4695 129.388 43.8081 129.388 43.8081L129.118 45.0816V45.0787Z",
    fill: "url(#paint43_linear_8168_48903)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M128.989 44.9403C128.989 44.9403 127.886 44.9943 127.725 44.6946C127.565 44.3949 127.497 43.7597 128.114 43.6907C128.731 43.6218 129.212 43.8975 129.212 43.8975L128.989 44.9403Z",
    fill: "url(#paint44_linear_8168_48903)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.776 48.8844C149.776 48.8844 145.523 48.9143 145.03 48.8844C144.538 48.8544 145.668 49.9661 145.668 49.9661L150.477 49.7684L149.776 48.8844Z",
    fill: "url(#paint45_linear_8168_48903)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.033 48.4629L164.366 48.157C164.233 47.7881 164.096 47.4462 163.968 47.1523C163.473 47.2633 163.137 47.3383 163.137 47.3383L163.033 48.4629Z",
    fill: "url(#paint46_linear_8168_48903)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138.238 51.6946C137.847 51.5657 137.526 52.3478 137.523 53.4415C137.52 54.5353 137.832 55.5272 138.223 55.659C138.615 55.7879 138.935 55.0058 138.938 53.912C138.941 52.8183 138.63 51.8264 138.238 51.6976V51.6946Z",
    fill: "url(#paint47_linear_8168_48903)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M124.99 49.6841C124.69 49.5793 124.441 50.2864 124.432 51.2633C124.423 52.2402 124.657 53.1182 124.954 53.2201C125.254 53.325 125.503 52.6178 125.512 51.6409C125.52 50.664 125.286 49.789 124.99 49.6841Z",
    fill: "url(#paint48_linear_8168_48903)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8168_48903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.614 115.299H81.5487C80.3801 115.299 79.4453 114.356 79.4453 113.178V38.2068C79.4453 37.028 80.3801 36.085 81.5487 36.085H132.497C133.665 36.085 134.6 37.028 134.6 38.2068V113.178C134.6 114.356 133.665 115.299 132.614 115.299Z",
    fill: "white"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.235 67.8188L89.8852 67.2602C89.8852 67.2602 91.1619 61.5145 87.9251 62.1096C84.6893 62.7038 84.386 65.9987 85.235 67.8188Z",
    fill: "url(#paint49_linear_8168_48903)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.438 70.25L114.168 69.6977C114.168 69.6977 115.445 63.952 112.208 64.5471C108.971 65.1423 108.627 66.5806 109.438 70.2511V70.25Z",
    fill: "url(#paint50_linear_8168_48903)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M123.518 66.9547C123.518 66.9547 125.641 65.8365 127.015 65.7863C128.39 65.7371 129.438 66.5551 129.438 66.5551C129.438 66.5551 130.427 67.2497 130.207 68.3156C129.986 69.3815 126.304 69.9275 124.266 69.6053C122.228 69.2831 122.4 68.6378 122.474 68.1179C122.547 67.597 123.518 66.9547 123.518 66.9547Z",
    fill: "url(#paint51_linear_8168_48903)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.492 68.614C115.397 66.6014 113.803 65.1025 112.108 65.2981C111.552 65.3619 113 65.1328 113.285 65.1328C116.887 65.1307 117.579 71.2457 113.966 71.8545L113.085 72.0031C114.462 71.7708 115.576 70.4016 115.491 68.614H115.492Z",
    fill: "url(#paint52_linear_8168_48903)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.58 65.2861C110.941 65.1773 109.591 66.5999 109.563 68.4629C109.535 70.3258 110.841 71.9241 112.48 72.0329C114.119 72.1417 115.469 70.7191 115.497 68.8562C115.525 66.9932 114.219 65.3949 112.58 65.2861Z",
    fill: "url(#paint53_linear_8168_48903)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.563 66.3604C111.445 66.2862 110.525 67.2558 110.506 68.5257C110.488 69.7956 111.377 70.8855 112.494 70.9587C113.611 71.033 114.532 70.0633 114.551 68.7935C114.569 67.5236 113.68 66.4347 112.563 66.3604Z",
    fill: "url(#paint54_linear_8168_48903)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1152 64.0305C87.5812 63.9646 87.8535 63.8799 88.188 63.8799C88.2356 63.8799 88.2843 63.8809 88.3329 63.8841C89.6697 63.973 90.7445 65.2795 90.7217 66.8077C90.702 68.1414 89.855 69.1989 88.7461 69.3851L88.0244 69.5064C89.1333 69.3192 89.9793 68.2617 90 66.929C90.0259 65.1979 88.6456 63.7721 87.1152 64.0295V64.0305Z",
    fill: "url(#paint55_linear_8168_48903)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6106 64.0057C86.2687 63.9168 85.1618 65.0821 85.139 66.6082C85.1162 68.1344 86.1859 69.4429 87.5278 69.5319C88.8697 69.6208 89.9766 68.4555 89.9994 66.9294C90.0222 65.4032 88.9526 64.0947 87.6106 64.0057Z",
    fill: "url(#paint56_linear_8168_48903)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5968 64.9465C86.7115 64.8879 85.9825 65.6557 85.967 66.662C85.9525 67.6682 86.6577 68.5312 87.5419 68.5898C88.4272 68.6484 89.1562 67.8806 89.1717 66.8743C89.1873 65.868 88.4811 65.0051 87.5968 64.9465Z",
    fill: "url(#paint57_linear_8168_48903)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.241 61.0057C117.241 61.0057 110.299 56.8604 107.176 56.8604L115.772 60.9252L117.241 61.0057Z",
    fill: "url(#paint58_linear_8168_48903)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.325 60.9081L107.658 61.2229C104.867 58.6717 103.694 57.5232 101.705 57.1058L107.392 56.8652C111.186 57.4792 115.87 60.6633 116.325 60.9081Z",
    fill: "url(#paint59_linear_8168_48903)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0811 66.5545C84.3265 67.3233 85.2346 67.8181 85.2346 67.8181C85.1165 67.4352 85.0099 66.8463 85.043 66.2344C85.1062 65.0702 85.6715 63.8212 87.6151 63.7574C89.2324 63.703 89.8506 65.0147 90.1861 66.1476C90.2658 66.4174 90.2938 66.6894 90.2896 66.9509C90.2875 67.067 90.2803 67.181 90.2679 67.2909C90.1902 67.9802 89.9324 68.5105 89.9324 68.5105L109.434 70.249H109.438C109.349 69.6047 109.322 69.0063 109.354 68.475C109.383 67.9812 109.463 67.5461 109.59 67.1863C110.298 65.1947 112.292 64.4447 114.157 65.4133C115.615 66.1716 116.009 67.7532 116.071 69.0105C116.121 70.0189 115.957 70.8191 115.957 70.8191C127.181 71.9634 130.371 69.635 130.371 69.635V67.0995C130.099 64.1016 126.213 62.7459 125.798 62.6089C129.071 63.725 129.409 66.522 129.438 66.5534C129.889 67.1361 130.103 67.9373 130.103 67.9373C129.903 68.2919 129.448 68.7689 128.59 69.0032C126.577 69.5534 124.085 69.4802 122.633 68.3923C122.725 67.9645 122.947 67.6047 123.144 67.3515C123.342 67.0984 123.517 66.953 123.517 66.953C123.028 66.5524 122.144 65.2365 121.101 64.6152C120.583 64.3223 119.992 64.0116 119.313 63.7585C117.717 63.1622 116.019 62.8704 114.429 62.6507C112.84 62.4321 111.344 62.3244 110.11 62.2114C109.49 62.1152 108.912 61.998 108.653 61.8673C107.965 61.521 104.848 58.2857 103.056 57.4918C101.264 56.6989 98.2273 56.7941 95.4347 57.0211C91.4224 57.3474 88.549 59.2386 87.6409 59.8087C86.7329 60.3788 85.5317 60.9259 84.9156 61.5692C84.3441 62.1675 84.0635 63.7009 83.9962 64.9394C83.9579 65.6559 83.991 66.2741 84.0811 66.5555V66.5545Z",
    fill: "url(#paint60_linear_8168_48903)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.968 63.8075C116.146 63.6245 118.877 64.3734 119.871 64.841C120.865 65.3086 122.434 66.2228 122.434 66.2228C122.434 66.2228 120.588 66.3211 118.839 66.0178C117.231 65.7395 115.59 64.1956 115.967 63.8065L115.968 63.8075Z",
    fill: "url(#paint61_linear_8168_48903)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.97 63.8074C116.097 63.5856 118.879 64.1683 119.873 64.6358C120.867 65.1034 122.266 66.095 122.266 66.095C122.266 66.095 120.554 66.0134 118.805 65.7111C117.197 65.4329 115.823 64.0637 115.97 63.8074Z",
    fill: "url(#paint62_linear_8168_48903)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M107.839 61.2231C108.208 61.5495 108.493 61.7859 108.653 61.8664C108.912 61.9972 109.489 62.1154 110.11 62.2106C112.477 62.4271 114.68 62.5809 117.037 63.1154C117.802 63.289 118.569 63.4993 119.32 63.7608C121.071 64.3695 122.748 66.3214 123.516 66.9522C123.753 66.902 123.984 66.8528 124.209 66.8047C126.062 66.4156 127.585 66.152 129.436 66.5526C129.436 66.5526 128.999 63.699 125.76 62.5965C122.522 61.494 116.324 60.9072 116.324 60.9072L107.838 61.2221L107.839 61.2231Z",
    fill: "url(#paint63_linear_8168_48903)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M106.628 61.6944C102.934 61.8241 92.974 60.9695 91.9975 60.8942C91.0221 60.8199 89.0061 60.5783 89.1262 59.7227L106.212 61.1431L106.627 61.6934L106.628 61.6944Z",
    fill: "url(#paint64_linear_8168_48903)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.285 61.2234C106.285 61.2234 103.179 57.6774 100.32 57.3772C97.1099 57.0404 91.6273 57.3688 89.255 59.5173C88.7208 60.0006 89.9364 60.4849 91.4461 60.5592C93.8317 60.6763 106.285 61.2234 106.285 61.2234Z",
    fill: "url(#paint65_linear_8168_48903)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M106.212 61.1419H105.017C105.017 61.1419 105.256 60.3051 104.723 60.0446C104.188 59.7842 101.788 59.689 101.519 60.3794C101.369 60.7653 101.812 61.0833 102.73 61.3082C103.611 61.5237 104.936 61.6565 106.628 61.6921L106.213 61.1419H106.212Z",
    fill: "url(#paint66_linear_8168_48903)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5508 56.8922C99.4954 56.8964 100.634 56.9183 101.731 57.1505L107.393 56.8671C107.107 56.82 106.827 56.7886 106.554 56.774C105.413 56.7123 103.719 56.6934 101.964 56.7436C100.537 56.7844 99.1164 56.8922 97.5508 56.8922Z",
    fill: "url(#paint67_linear_8168_48903)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M115.957 70.8202C127.18 71.9645 130.37 69.6361 130.37 69.6361V68.8076C129.906 69.1256 129.25 69.4541 128.34 69.6978C125.86 70.361 122.264 69.5074 122.264 69.5074L116.071 69.0126C116.121 70.021 115.957 70.8212 115.957 70.8212V70.8202Z",
    fill: "url(#paint68_linear_8168_48903)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0062 69.0842C96.0062 69.0842 95.6872 64.0016 95.9078 61.2244C96.1283 58.4473 96.9505 56.9326 96.9505 56.9326H97.2394C97.2394 56.9326 96.5767 58.4473 96.3561 61.2244C96.1356 64.0016 96.3561 69.0842 96.3561 69.0842H96.0072H96.0062Z",
    fill: "url(#paint69_linear_8168_48903)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M109.438 70.2502C109.35 69.6058 109.322 69.0065 109.354 68.4761L90.2908 66.9531C90.2794 67.7994 89.9336 68.5127 89.9336 68.5127L109.439 70.2512L109.438 70.2502Z",
    fill: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M89.9327 68.5106L109.434 70.2491C109.321 70.2303 106.909 69.837 106.283 69.3464C105.644 68.8443 105.037 68.4447 104.18 68.4008C103.411 68.361 92.4674 67.4709 90.2671 67.292C90.1895 67.9813 89.9316 68.5116 89.9316 68.5116L89.9327 68.5106Z",
    fill: "url(#paint70_linear_8168_48903)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M84.0811 66.5546C84.3265 67.3234 85.2346 67.8182 85.2346 67.8182C85.1165 67.4353 85.0099 66.8464 85.043 66.2345C85.043 66.2345 84.108 65.8841 83.9962 64.9416C83.9962 64.9406 83.9962 64.9395 83.9962 64.9385C83.9579 65.655 83.991 66.2732 84.0811 66.5546Z",
    fill: "url(#paint71_linear_8168_48903)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.159 62.7588C115.778 62.8571 116.408 62.9743 117.038 63.1165C117.803 63.2902 118.57 63.5004 119.321 63.7619C121.072 64.3707 122.749 66.3226 123.516 66.9533C123.753 66.9031 123.984 66.8539 124.21 66.8058C122.022 63.8906 118.274 63.2305 115.158 62.7588H115.159Z",
    fill: "url(#paint72_linear_8168_48903)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.018 90.4267H86.2363C85.8857 90.4267 85.5352 90.073 85.5352 89.7194V89.4836C85.5352 89.13 85.8857 88.7764 86.2363 88.7764H127.018C127.369 88.7764 127.719 89.13 127.719 89.4836V89.7194C127.719 90.073 127.486 90.4267 127.018 90.4267Z",
    fill: "#F4F4F4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.018 95.496H86.2363C85.8857 95.496 85.5352 95.1424 85.5352 94.7887V94.553C85.5352 94.1993 85.8857 93.8457 86.2363 93.8457H127.018C127.369 93.8457 127.719 94.1993 127.719 94.553V94.7887C127.719 95.1424 127.486 95.496 127.018 95.496Z",
    fill: "#F4F4F4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8699 100.446H86.3531C85.8857 100.446 85.5352 100.093 85.5352 99.6211C85.5352 99.1495 85.8857 98.7959 86.3531 98.7959H96.8699C97.3374 98.7959 97.6879 99.1495 97.6879 99.6211C97.6879 100.093 97.3374 100.446 96.8699 100.446Z",
    fill: "#F4F4F4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8699 84.7694H86.3531C85.8857 84.7694 85.5352 84.4158 85.5352 83.9443C85.5352 83.4728 85.8857 83.1191 86.3531 83.1191H96.8699C97.3374 83.1191 97.6879 83.4728 97.6879 83.9443C97.6879 84.4158 97.3374 84.7694 96.8699 84.7694Z",
    fill: "#DFDFDF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5188 11.9979C34.1617 12.7639 34.9199 14.6789 34.288 16.3385C33.5298 17.9982 31.6342 18.7641 29.9913 18.1258C28.3484 17.3598 27.5902 15.4449 28.222 13.7852C28.8539 11.9979 30.8759 11.2319 32.5188 11.9979Z",
    fill: "#59CF1E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M35.93 6.50709C36.4355 5.3581 37.6992 4.84744 38.8366 5.3581C39.974 5.86876 40.4795 7.14541 39.974 8.29439C39.4685 9.44337 38.2047 9.95403 37.0674 9.44337C35.93 9.06038 35.4245 7.65607 35.93 6.50709Z",
    fill: "#59CF1E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M181.766 152.81C178.733 152.427 176.459 149.619 176.838 146.555C177.217 143.491 179.997 141.193 183.03 141.576C186.063 141.959 188.338 144.768 187.959 147.832C187.706 150.895 184.926 153.193 181.766 152.81Z",
    fill: "#59CF1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8168_48903",
    x: 0.75391,
    y: 36.0332,
    width: 124.201,
    height: 148.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_48903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_48903",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8168_48903",
    x: 82.5508,
    y: 11.5156,
    width: 124.201,
    height: 148.144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_48903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_48903",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8168_48903",
    x: 44.9219,
    y: 18.8232,
    width: 124.201,
    height: 148.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_48903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_48903",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8168_48903",
    x1: 49.1405,
    y1: 120.482,
    x2: 53.08,
    y2: 120.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8168_48903",
    x1: 56.4559,
    y1: 119.529,
    x2: 60.3953,
    y2: 119.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8168_48903",
    x1: 63.7715,
    y1: 121.292,
    x2: 67.711,
    y2: 121.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8168_48903",
    x1: 71.0888,
    y1: 122.752,
    x2: 75.0283,
    y2: 122.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8168_48903",
    x1: 57.3534,
    y1: 98.2475,
    x2: 73.6384,
    y2: 85.4973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8168_48903",
    x1: 68.3151,
    y1: 78.2212,
    x2: 71.354,
    y2: 91.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8168_48903",
    x1: 61.4447,
    y1: 99.8454,
    x2: 63.1279,
    y2: 93.7379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8168_48903",
    x1: 63.7697,
    y1: 86.3004,
    x2: 64.6618,
    y2: 90.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8168_48903",
    x1: 67.7003,
    y1: 102.924,
    x2: 68.9544,
    y2: 98.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8168_48903",
    x1: 81.7171,
    y1: 98.4939,
    x2: 82.6303,
    y2: 95.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8168_48903",
    x1: 66.3062,
    y1: 104.925,
    x2: 67.685,
    y2: 99.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8168_48903",
    x1: 69.7944,
    y1: 99.041,
    x2: 69.8675,
    y2: 90.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8168_48903",
    x1: 46.0433,
    y1: 104.062,
    x2: 47.4496,
    y2: 98.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8168_48903",
    x1: 80.2158,
    y1: 101.744,
    x2: 81.4029,
    y2: 97.4383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8168_48903",
    x1: 83.1459,
    y1: 96.638,
    x2: 83.2068,
    y2: 89.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8168_48903",
    x1: 61.5979,
    y1: 85.1541,
    x2: 65.395,
    y2: 101.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8168_48903",
    x1: 54.8895,
    y1: 93.6726,
    x2: 54.9535,
    y2: 99.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8168_48903",
    x1: 55.705,
    y1: 96.4975,
    x2: 59.3149,
    y2: 86.4819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8168_48903",
    x1: 75.0771,
    y1: 102.835,
    x2: 76.1242,
    y2: 99.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8168_48903",
    x1: 79.2715,
    y1: 89.6465,
    x2: 79.5181,
    y2: 88.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8168_48903",
    x1: 78.2048,
    y1: 89.4539,
    x2: 80.0199,
    y2: 88.0326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8168_48903",
    x1: 60.4476,
    y1: 96.1471,
    x2: 60.0757,
    y2: 90.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8168_48903",
    x1: 44.2977,
    y1: 94.5834,
    x2: 43.9198,
    y2: 88.6608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8168_48903",
    x1: 72.3316,
    y1: 101.297,
    x2: 66.6197,
    y2: 93.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8168_48903",
    x1: 85.4104,
    y1: 98.6837,
    x2: 80.3069,
    y2: 91.6662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8168_48903",
    x1: 161.754,
    y1: 72.0733,
    x2: 165.778,
    y2: 72.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8168_48903",
    x1: 158.846,
    y1: 82.3776,
    x2: 165.778,
    y2: 82.3776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8168_48903",
    x1: 163.503,
    y1: 92.6806,
    x2: 165.779,
    y2: 92.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8168_48903",
    x1: 164.148,
    y1: 54.6107,
    x2: 146.361,
    y2: 40.6819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8168_48903",
    x1: 148.951,
    y1: 54.6729,
    x2: 133.732,
    y2: 42.7564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8168_48903",
    x1: 140.316,
    y1: 58.8184,
    x2: 139.074,
    y2: 54.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8168_48903",
    x1: 126.4,
    y1: 54.4156,
    x2: 125.49,
    y2: 51.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8168_48903",
    x1: 141.704,
    y1: 60.8009,
    x2: 140.337,
    y2: 55.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8168_48903",
    x1: 138.241,
    y1: 54.9605,
    x2: 138.168,
    y2: 46.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8168_48903",
    x1: 161.826,
    y1: 59.9445,
    x2: 160.432,
    y2: 54.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8168_48903",
    x1: 127.893,
    y1: 57.6453,
    x2: 126.714,
    y2: 53.3693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8168_48903",
    x1: 124.983,
    y1: 52.5729,
    x2: 124.92,
    y2: 45.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8168_48903",
    x1: 153.488,
    y1: 39.2323,
    x2: 94.3155,
    y2: 106.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8168_48903",
    x1: 155.16,
    y1: 32.8376,
    x2: 142.776,
    y2: 46.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8168_48903",
    x1: 144.295,
    y1: 37.1433,
    x2: 134.27,
    y2: 47.8322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8168_48903",
    x1: 153.615,
    y1: 49.2731,
    x2: 151.331,
    y2: 61.8026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8168_48903",
    x1: 151.096,
    y1: 44.1257,
    x2: 149.093,
    y2: 55.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8168_48903",
    x1: 131.792,
    y1: 52.1919,
    x2: 131.157,
    y2: 55.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8168_48903",
    x1: 129.598,
    y1: 43.071,
    x2: 128.024,
    y2: 44.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8168_48903",
    x1: 129.888,
    y1: 45.4407,
    x2: 128.082,
    y2: 44.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8168_48903",
    x1: 147.519,
    y1: 52.0847,
    x2: 147.891,
    y2: 46.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8168_48903",
    x1: 163.559,
    y1: 50.5382,
    x2: 163.937,
    y2: 44.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8168_48903",
    x1: 135.717,
    y1: 57.2022,
    x2: 141.39,
    y2: 49.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8168_48903",
    x1: 122.726,
    y1: 54.6045,
    x2: 127.795,
    y2: 47.6354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8168_48903",
    x1: 88.8032,
    y1: 67.1525,
    x2: 86.4845,
    y2: 64.0212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8168_48903",
    x1: 112.715,
    y1: 67.7689,
    x2: 109.766,
    y2: 67.0393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8168_48903",
    x1: 125.752,
    y1: 75.9034,
    x2: 126.503,
    y2: 66.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_8168_48903",
    x1: 115.579,
    y1: 73.2562,
    x2: 114.627,
    y2: 69.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_8168_48903",
    x1: 112.33,
    y1: 63.0225,
    x2: 112.78,
    y2: 75.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_8168_48903",
    x1: 113.44,
    y1: 72.0319,
    x2: 112.799,
    y2: 69.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_8168_48903",
    x1: 90.0766,
    y1: 70.5263,
    x2: 89.2968,
    y2: 67.6998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_8168_48903",
    x1: 87.62,
    y1: 61.512,
    x2: 87.5079,
    y2: 72.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_8168_48903",
    x1: 88.2916,
    y1: 69.4412,
    x2: 87.784,
    y2: 67.5976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_8168_48903",
    x1: 112.071,
    y1: 57.2505,
    x2: 112.675,
    y2: 64.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_8168_48903",
    x1: 104.903,
    y1: 60.4562,
    x2: 112.093,
    y2: 57.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_8168_48903",
    x1: 125.67,
    y1: 45.9856,
    x2: 99.6527,
    y2: 73.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_8168_48903",
    x1: 118.857,
    y1: 69.2322,
    x2: 119.241,
    y2: 64.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_8168_48903",
    x1: 117.386,
    y1: 65.5542,
    x2: 120.382,
    y2: 64.5198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_8168_48903",
    x1: 122.322,
    y1: 59.6353,
    x2: 99.5506,
    y2: 85.4058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_8168_48903",
    x1: 98.0435,
    y1: 58.8942,
    x2: 97.8174,
    y2: 61.3247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_8168_48903",
    x1: 95.4273,
    y1: 56.9975,
    x2: 99.5086,
    y2: 63.1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8EBF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_8168_48903",
    x1: 103.977,
    y1: 60.1147,
    x2: 104.236,
    y2: 63.2084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_8168_48903",
    x1: 102.449,
    y1: 56.6097,
    x2: 102.547,
    y2: 57.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_8168_48903",
    x1: 115.403,
    y1: 65.5085,
    x2: 128.695,
    y2: 72.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_8168_48903",
    x1: 97.2228,
    y1: 54.5341,
    x2: 95.6698,
    y2: 69.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_8168_48903",
    x1: 99.9309,
    y1: 67.997,
    x2: 99.3491,
    y2: 71.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_8168_48903",
    x1: 84.4041,
    y1: 64.3297,
    x2: 84.8014,
    y2: 69.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_8168_48903",
    x1: 119.135,
    y1: 71.9637,
    x2: 119.788,
    y2: 63.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8168_48903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6636,
    height: 18.8194,
    fill: "white",
    transform: "translate(42.7832 83.8447)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8168_48903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.3762,
    height: 19.0012,
    fill: "white",
    transform: "translate(123.686 39.5557)"
  })))));
};
export default SvgCarRentalsStep2;